// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DragPreview16BindJs from "./DragPreview16.bind.js";

var make = DragPreview16BindJs.Preview;

export {
  make ,
  
}
/* make Not a pure module */
